const DEFAULT_NAMESPACE = 'disclosure';
const DEFAULT_SELECTOR = `[data-js-${DEFAULT_NAMESPACE}]`;

const ACTIVE_CLASS = 'state-active';
const OPEN_CLASS = 'state-open';

export class Disclosure {
    constructor(node, config = {}) {
        this.elNode = node;
        this.namespace = config.namespace || DEFAULT_NAMESPACE;

        this.elButton = this.elNode.querySelector(
            `[data-js-${this.namespace}-button]`
        );

        this.elContent = this.elNode.querySelector(
            `[data-js-${this.namespace}-content]`
        );
    }

    init() {
        if (!this.elButton || !this.elContent) return;

        if (!this.elButton.hasAttribute('aria-expanded')) {
            this.elButton.setAttribute('aria-expanded', 'false');
        }

        this._updateDOM(false);

        this._onTriggerClick = this._onTriggerClick.bind(this);
        this.elButton.addEventListener('click', this._onTriggerClick);
    }

    destroy() {
        this.elButton.removeEventListener('click', this._onTriggerClick);
    }

    isOpen() {
        return this.elButton.getAttribute('aria-expanded') === 'true';
    }

    toggle() {
        this.isOpen() ? this.close() : this.open();
    }

    open() {
        if (this.isOpen()) return;
        this._updateDOM(true);
    }

    close() {
        if (!this.isOpen()) return;
        this._updateDOM(false);
    }

    _updateDOM(isOpen) {
        this.elButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
            this.elButton.classList.add(ACTIVE_CLASS);
            this.elContent.classList.add(OPEN_CLASS);
            this.elContent.removeAttribute('hidden');
        } else {
            this.elButton.classList.remove(ACTIVE_CLASS);
            this.elContent.classList.remove(OPEN_CLASS);
            this.elContent.setAttribute('hidden', '');
        }
    }

    _onTriggerClick() {
        this.toggle();
    }
}

export default function factory(selector = DEFAULT_SELECTOR) {
    const nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    return Array.from(nodes).map((node) => {
        const module = new Disclosure(node);
        module.init();
        return module;
    });
}
